import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';

import { profilePropType } from '../../../../components/UIContainer/MobileUI/MainShell/propTypes/index';
import { getOrigin } from '../../../../libs/Origin';
import styles from './mobileMenu.module.css';

const Guest = ({ id, changePage }) => (
  <ul>
    <li>
      <a href={`https://${getOrigin()}/home?page=practice-profile/${id}`}>
        Log in / Join
      </a>
    </li>
    <li>
      <a href="https://vensa.com">List your Practice</a>
    </li>
    <li onClick={changePage(0)}>Home</li>
  </ul>
);

const LoggedIn = ({
  logout,
  profile,
  goDependants,
  goPractices,
  changePage,
}) => (
  <div>
    <ul>
      <li className={styles.user} onClick={changePage(0)}>
        My Health Feed
        {profile.avatar && (
          <img
            src={profile.avatar}
            alt={`${profile.firstName} ${profile.lastName}`}
          />
        )}
      </li>
      <li onClick={goDependants}>Dependants</li>
      <li onClick={goPractices}>Practices</li>
    </ul>
    <ul>
      <li onClick={changePage(1)}>Appointments</li>
      <li onClick={changePage(2)}>Prescriptions</li>
    </ul>
    <ul>
      <li onClick={logout}>Log out</li>
      <li onClick={changePage(0)}>Home</li>
    </ul>
  </div>
);

const MobileMenu = ({
  id,
  open,
  practice,
  profile,
  goDependants,
  goPractices,
  changePage,
  isLoggedIn,
  logout,
}) => (
  <CSSTransitionGroup
    component="div"
    transitionName={{
      leave: styles.leave,
      leaveActive: styles.leaveActive,
      enter: styles.enter,
      enterActive: styles.enterActive,
    }}
    transitionLeaveTimeout={600}
    transitionEnterTimeout={600}
  >
    {open && (
      <div className={styles.menu}>
        <div className={styles.name}>{practice}</div>
        {isLoggedIn ? (
          <LoggedIn
            logout={logout}
            profile={profile}
            goDependants={goDependants}
            goPractices={goPractices}
            changePage={changePage}
          />
        ) : (
          <Guest id={id} changePage={changePage} />
        )}
      </div>
    )}
  </CSSTransitionGroup>
);

MobileMenu.propTypes = {
  id: PropTypes.string.isRequired,
  practice: PropTypes.string.isRequired,
  profile: profilePropType.isRequired,
  open: PropTypes.bool.isRequired,
  goPractices: PropTypes.func.isRequired,
  goDependants: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

LoggedIn.propTypes = {
  profile: profilePropType.isRequired,
  goPractices: PropTypes.func.isRequired,
  goDependants: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

Guest.propTypes = {
  id: PropTypes.string.isRequired,
  changePage: PropTypes.func.isRequired,
};

export default MobileMenu;
